
import React from 'react';
import {drawer,drawerShow} from '../Menu/drawer-bootstrap'
import $ from 'jquery'
export default class ThemesComponent extends React.Component{
    constructor(props){
        super(props)
        this.state={hover: false,
        open:false}
        this.toggleHovern.bind(this);
        this.openDrawers = this.openDrawers.bind(this);
        // console.log(this.props.enter)
      }
      componentDidUpdate(){
      //  if(this.state.open){
      //   drawer({
      //     exitResizeing: false,
      //     customJqueryElement: $(".nav .nav-item").clone(true),
      //     customHeadDrawer: `<div>Drawer</div>`,
      //     class: {
      //       showButton: "theme"+this.props.index+""
      //     },
      //     defualtStylesPosition: this.props.index
      //   })
      //   drawerShow()
      //  }
      }
      openDrawers(){
        
        // this.setState(state =>({open: true}))
        drawer({
          exitResizeing: false,
          customJqueryElement: $(".nav .nav-item").clone(true),
          customHeadDrawer: `<div>Drawer</div>`,
          class: {
            showButton: "theme"+this.props.index+""
          },
          defualtStylesPosition: this.props.index
        })
        drawerShow()
      }
      toggleHovern(){
          // console.log("hovers")
        this.setState(state =>({hover: !state.hover}))
      }
    render(){
        // var linkStyle;
        //     if (this.state.hover) {
        //     linkStyle = this.props.enter
        //     } else {
        //     linkStyle = this.props.leave
        //     }
        return(
        <div className={"theme theme"+this.props.index+""}
        onClick={this.openDrawers}
        style={this.props.mainStyle}  >
            <div style={
            (this.state.hover)? this.props.enter :this.props.leave
          }  onMouseEnter={()=>this.setState(state =>({hover: !state.hover}))} 
          onMouseLeave={()=>this.setState(state =>({hover: !state.hover}))}
          >theme {this.props.index}
          </div>
          </div>
        )
    }
}